import React from "react";

const HOURS = Array.from({ length: 24 }, (_, i) => {
  const h = String(i).padStart(2, "0");
  return { value: `${h}:00`, label: `${h}:00` };
});

export default function TimeSelect({ value, onChange, className = "" }) {
  return (
    <select
      value={value || "09:00"}
      onChange={(e) => onChange?.(e.target.value)}
      className={`border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white ${className}`}
    >
      {HOURS.map((h) => (
        <option key={h.value} value={h.value}>
          {h.label}
        </option>
      ))}
    </select>
  );
}
